<template>
  <BaseOption>
    <template v-slot:body>
      <div class="main-card mb-3 card manufacture-options">
        <div class="card-header">
          Manufactures
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div v-show="data.detail.open_blueprint" class="position-relative form-group col-12 detail-open-blueprint">
              <label class="col-12 mb-0 p-0 font-weight-bold">Open Blueprint</label>
              <div class="btn-group-sm nav btn-group mt-2 d-inline-block">
                <div v-for="(object, index) in data.detail.open_blueprint" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                  <input type="radio" name="manufacture[detail][open_blueprint]" :value="index" :checked="values.detail.open_blueprint == index" @change="store.commit('values.detail.open_blueprint', index)" />
                  <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
                </div>
              </div>
            </div>
            <div v-show="data.tablelist.more" class="position-relative form-group col-12 tablelist-more">
              <label class="col-12 mb-0 p-0 font-weight-bold">More in tablelist</label>
              <div class="btn-group-sm nav btn-group mt-2 d-inline-block">
                <div v-for="(object, index) in data.tablelist.more" :key="index" class="checkbox-container btn-shadow btn btn-primary show p-0">
                  <input type="checkbox" name="manufacture[tablelist][more][]" :value="index" :checked="Object.values(values.tablelist.more).indexOf(index) != -1" @click="handleChangeTablistMore" />
                  <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
                </div>
              </div>
            </div>
            <div class="position-relative form-group col-12">
              <label class="col-12 mb-0 p-0 font-weight-bold">Google Sheet Config</label>
              <div class="mt-2 row">
                <div class="col-12 mb-3">
                  <textarea class="form-control" rows="4" placeholder="Google Service Account JSON" :value="values.google_sheet?.config_key" @change="store.commit('values.google_sheet.config_key', $event.target.value)"></textarea>
                  <small class="form-text text-muted">
                    <b>Instructions:</b> 1. Create a Service Account at <a href="https://console.cloud.google.com/iam-admin/serviceaccounts" target="_blank" rel="noopener noreferrer">Google Cloud Console</a> &gt; 2. Create a Key (JSON format) &gt; 3. Share Google Sheet Editor permission with the Service Account Email &gt; 4. Paste the JSON here.
                  </small>
                </div>
                <div class="col-12 mb-3">
                  <input type="text" class="form-control" placeholder="Spreadsheet ID" :value="values.google_sheet?.file_id" @change="store.commit('values.google_sheet.file_id', $event.target.value)" />
                </div>
                <div class="col-12">
                  <input type="text" class="form-control" placeholder="Sheet Name (default: Sheet1)" :value="values.google_sheet?.sheet_name" @change="store.commit('values.google_sheet.sheet_name', $event.target.value)" />
                </div>
              </div>
            </div>
            <div class="position-relative form-group col-12 statuses-more">
              <label class="col-12 mb-0 p-0 font-weight-bold">Statuses</label>
              <div class="btn-group-sm mt-2">
                <draggable :model-value="values.detail.statuses || []" @update:modelValue="changeStatusesPriority" @start="drag = true" @end="drag = false" v-bind="{ animation: 200 }" handle=".handle" item-key="id" class="list-group">
                  <template #item="{ element, index }">
                    <div :class="`w-100 status-item pt-3 pb-3 mb-2 type-${element.type}`">
                      <i class="ti ti-menu-order handle"></i>
                      <div class="w-100">
                        <div class="d-flex w-100">
                          <input type="text" placeholder="Status" class="form-control w-20 h-100 mr-2" :value="element.id" @change="store.commit(`values.detail.statuses.${index}.id`, $event.currentTarget.value)" :readonly="element.default" />
                          <input type="text" placeholder="Label" class="form-control w-20 h-100 mr-2" :value="element.label" @change="store.commit(`values.detail.statuses.${index}.label`, $event.currentTarget.value)" />
                          <Select :options="data.detail.status_type || []" data-title="Status Type" placeholder="Status Type" class="has-tip w-20 h-100 mr-2" :class="element.type" :value="element?.type" @changeValue="store.commit(`values.detail.statuses.${index}.type`, $event)" :disabled="element.default ? true : false"></Select>
                          <Select v-if="element.type == 1" :options="data.detail.capability || []" data-title="Permission" placeholder="Permission" class="has-tip w-40 h-100" :value="element.capabilities" @changeValue="store.commit(`values.detail.statuses.${index}.capabilities`, $event)" multiple></Select>
                          <Select v-if="element.type == 2" :options="statusOptions" data-title="Same Status" placeholder="Same Status" class="has-tip w-20 h-100 mr-2" :value="element.same" @changeValue="store.commit(`values.detail.statuses.${index}.same`, $event)"></Select>
                          <Select v-if="element.type == 2" :options="data.detail.status_cause || []" data-title="Cause" placeholder="Cause" class="has-tip w-20 h-100" :value="element.cause ? 1 : 0" @changeValue="store.commit(`values.detail.statuses.${index}.cause`, $event)"></Select>
                        </div>
                        <div v-if="element.type == 1" class="d-flex mt-2 w-100">
                          <Select :options="data.detail.status_group || []" data-title="Group" placeholder="Group" class="has-tip flex-1 h-100 mr-2" :value="element.group" @changeValue="store.commit(`values.detail.statuses.${index}.group`, $event)" multiple></Select>
                          <Select :options="data.detail.status_step || []" data-title="Step" placeholder="Step" class="has-tip flex-1 h-100 mr-2" :value="element.step" @changeValue="store.commit(`values.detail.statuses.${index}.step`, $event)" multiple></Select>
                          <Select :options="statusOptions" data-title="Next Status" placeholder="Next Status" class="has-tip flex-1 h-100 mr-2" :value="element.next.status" @changeValue="store.commit(`values.detail.statuses.${index}.next.status`, $event)" multiple></Select>
                          <Select :options="data.detail.capability || []" data-title="Next Status Permission" placeholder="Next Status Permission" class="has-tip flex-1 h-100" :value="element.next.capabilities" @changeValue="store.commit(`values.detail.statuses.${index}.next.capabilities`, $event)" multiple></Select>
                        </div>
                      </div>
                    </div>
                  </template>
                </draggable>
                <a @click.prevent="handleAddStatus" href="#add-more" class="btn btn-outline-primary add-more mt-2">Add More</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseOption>
</template>

<script>
import draggable from 'vuedraggable'
import Event from '@/helper/event.js'
import BaseOption from '@/views/Option/BaseOption.vue'
export default {
  mixins: [Event],
  components: {
    BaseOption,
    draggable
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'manufacture/option'
    },
    submitUri() {
      return 'manufacture/option/update'
    },
    data() {
      return this.store.getter('data', {
        flags: {},
        detail: {},
        tablelist: {
          more: {}
        }
      })
    },
    values() {
      return this.store.getter('values', {
        flags: [],
        detail: {
          open_blueprint: '',
          statuses: []
        },
        tablelist: {
          more: []
        },
        google_sheet: {
          config_key: '',
          file_id: ''
        }
      })
    },
    statusOptions() {
      return this.values?.detail?.statuses.reduce((result, item) => {
        result.push({
          id: item.id,
          text: item.label
        })
        return result
      }, [])
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status != 'success') return
      data.values = Object.assign(
        {
          flags: ['empty', 'yellow', 'orange', 'red', 'green', 'blue'],
          detail: {
            open_blueprint: 'link',
            statuses: []
          },
          tablelist: {
            more: ['refer_order', 'blueprint']
          },
          google_sheet: {
            config_key: '',
            file_id: ''
          }
        },
        data.values
      )
      data.values.detail.statuses = data.values.detail.statuses.map((item) => {
        return Object.assign(
          {
            id: '',
            label: '',
            same: '',
            default: 0,
            cause: 0,
            group: [],
            step: [],
            capabilities: [],
            next: {
              status: [],
              capabilities: []
            }
          },
          item
        )
      })

      this.store.commit('', data)
    },
    handleChangeFlag(e) {
      let values = Object.values(this.values.flags || [])
      if (e.target.checked == true) {
        values.push(e.target.value)
      } else if (values.indexOf(e.target.value) !== -1) {
        values.splice(values.indexOf(e.target.value), 1)
      }
      this.store.commit('values.flags', values)
    },
    handleChangeTablistMore(e) {
      let values = Object.values(this.values.tablelist.more || [])
      if (values.indexOf(e.currentTarget.value) != -1) {
        values.splice(values.indexOf(e.target.value), 1)
      } else {
        values.push(e.currentTarget.value)
      }
      this.store.commit('values.tablelist.more', values)
    },
    handleAddStatus() {
      let statuses = this.values.detail.statuses
      statuses.push({
        id: '',
        label: '',
        same: '',
        cause: 0,
        group: [],
        step: [],
        capabilities: [],
        next: {
          status: [],
          capabilities: []
        }
      })
      this.store.commit('values.detail.statuses', statuses)
    },
    changeStatusesPriority(value) {
      this.store.commit('values.detail.statuses', value)
    },
    handleClickSave() {
      this.submitForm(this.store.getter('values', {}))
    }
  }
}
</script>
<style lang="scss">
.manufacture-options .statuses-more {
  .status-item {
    display: flex;
    align-items: center;
    border: 1px dashed;
    border-radius: 5px;
    padding: 10px;
    margin: 10px 0;
    border-color: #0096c7;
    background-color: #0096c71a;
    &.type-2 {
      border-color: #c4c5c5;
      background-color: #bdbdbd1a;
    }
    .flip-list-move {
      transition: transform 0.5s;
    }
    .no-move {
      transition: transform 0s;
    }
    .ghost {
      opacity: 0.5;
      background: #c8ebfb;
    }
    [readonly],
    [disabled],
    .is-disabled .multiselect-wrapper {
      cursor: not-allowed;
    }
    i {
      cursor: move;
      font-size: 20px;
      color: #4b4b4b;
      border: 1px solid;
      border-radius: 5px;
      padding: 2px;
      margin-right: 10px;
    }
  }
}
</style>
